import React, { useContext, useEffect } from 'react';
import { LeReacteurContext } from 'src/components/Layout';
/* --- import Components ----*/
import SocialMedia from 'src/components/LandingPage/SocialMedia';
import { SuccessBlockContainer } from '../elements';
import { Sentence, TitleDescription } from 'src/components/Typography';
/* --- import Styles ----*/
import colors from 'src/style/colors';
import { mediaQueries } from 'src/style/breakpoints';
import Astronaut from 'src/components/Illustrations/Astronaut.svg';

const ApplySuccessBlockLanding = ({ name, certification, courseType }) => {
  const { dtlFormValidation } = useContext(LeReacteurContext);

  useEffect(() => {
    dtlFormValidation(`landing_${courseType}`);
  }, []);

  return (
    <SuccessBlockContainer
      css={{
        [mediaQueries.desktopUp]: {
          marginTop: 60,
        },
        [mediaQueries.phoneOnly]: {
          marginTop: 60,
        },
      }}
    >
      <TitleDescription css={{ fontWeight: 'bold', color: colors.black, paddingBottom: 20 }}>
        Merci pour votre intérêt, {name}&nbsp;!
      </TitleDescription>
      <br />
      <Sentence css={{ paddingTop: 0, fontWeight: 400 }}>
        Vous allez recevoir un mail de confirmation
        <br />
        <br />
        (vérifiez vos SPAMs ou vos communications commerciales si vous utilisez Gmail)
        {certification === 'RNCP6' ? ' avec un test de logique à réaliser' : ''}.<br />
        <br />
        <br />
        <br />
        Sandrine qui s'occupe des inscriptions va vous rappeler au plus vite
        {certification === 'RNCP6' ? ', une fois le test passé' : ''} !{' '}
        <span role="img" aria-label="emoji smile">
          🙂
        </span>
        <br />
        <br />
        En attendant, n’hésitez pas à parcourir notre site Web ainsi que nos différents réseaux
        sociaux.
        <br />
        <br />
      </Sentence>
      <SocialMedia origin="applyForm" />
      <div
        css={{
          position: 'absolute',
          bottom: -4,
          width: '100%',
        }}
      >
        <img
          src={Astronaut}
          alt="illustration demi lune"
          css={{ width: '100%', paddingLeft: 100 }}
        />
      </div>
    </SuccessBlockContainer>
  );
};
export default ApplySuccessBlockLanding;
